export enum RouteLandingNames {
  LANDING = "Landing",
  LANDING_BUILDERS = "LandingBuilders",
  LANDING_PLANS = "PlansLanding",
}
